var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollboxWrapper",
      staticClass: "all-reply-wrapper",
      class: {
        "box-overflow-hidden": _vm.callQuitWarning || _vm.callCommentInput
      }
    },
    [
      _vm.ajaxDone
        ? _c(
            "div",
            {
              ref: "scrollbox",
              staticClass: "all-reply",
              class: { "all-reply-padding-set": _vm.KBTitle }
            },
            [
              _c("div", { staticClass: "reply-title reply-item" }, [
                _c("div", { staticClass: "comment-head-image" }, [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.mainCommentInfo.HeadImage ||
                        "/static/images/default.png"
                    },
                    on: { error: _vm.$imgErr }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "comment-info" }, [
                  _c("div", { staticClass: "comment-head" }, [
                    _c("div", { staticClass: "comment-head-name" }, [
                      _vm._v(_vm._s(_vm.mainCommentInfo.Name))
                    ]),
                    _vm._v(" "),
                    _vm.mainCommentInfo.Identity == 1
                      ? _c("div", { staticClass: "knowledge-expert" }, [
                          _c("img", {
                            attrs: {
                              src: "/static/images/knowledge_expert.png",
                              alt: ""
                            }
                          })
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "comment-time" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$calcTime(_vm.mainCommentInfo.CreateDate + "000")
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.mainCommentInfo.IsDel &&
                  _vm.mainCommentInfo.Comment &&
                  _vm.mainCommentInfo.Comment.length
                    ? _c("div", {
                        staticClass: "comment-content",
                        domProps: {
                          textContent: _vm._s(_vm.mainCommentInfo.Comment)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mainCommentInfo.IsDel
                    ? _c("div", { staticClass: "content-delete-tip" }, [
                        _c("span", { staticClass: "left-cane" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "delete-tip" }, [
                          _vm._v("评论已删除")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "right-cane" })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.mainCommentInfo.IsDel &&
                  _vm.mainCommentInfo &&
                  _vm.mainCommentInfo.AttachList
                    ? _c(
                        "div",
                        { staticClass: "comment-attachment" },
                        _vm._l(_vm.mainCommentInfo.AttachList, function(
                          attachment,
                          index
                        ) {
                          return index < 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "source-img-wrapper",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showImg(
                                        index,
                                        _vm.mainCommentInfo.AttachList
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "source-img",
                                    attrs: { src: attachment },
                                    on: { error: _vm.$commentImgErr }
                                  })
                                ]
                              )
                            : _vm._e()
                        }),
                        0
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "reply-list" },
                [
                  _c("div", { staticClass: "reply-list-title" }, [
                    _vm._v("全部回复(" + _vm._s(_vm.totalReplyCount) + ")")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.replyList, function(replys, index) {
                    return !replys.IsDel
                      ? _c(
                          "div",
                          {
                            staticClass: "reply-item",
                            class: {
                              "comment-mark":
                                replys.CommentId == _vm.subCommentId
                            },
                            on: {
                              click: function($event) {
                                return _vm.addComment(replys)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "comment-head-image" }, [
                              _c("img", {
                                attrs: {
                                  src:
                                    replys.HeadImage ||
                                    "/static/images/default.png"
                                },
                                on: { error: _vm.$imgErr }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "comment-info" }, [
                              _c("div", { staticClass: "comment-head" }, [
                                _c(
                                  "div",
                                  { staticClass: "comment-head-name" },
                                  [_vm._v(_vm._s(replys.ReplyBy))]
                                ),
                                _vm._v(" "),
                                replys.Identity == 1
                                  ? _c(
                                      "div",
                                      { staticClass: "knowledge-expert" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src:
                                              "/static/images/knowledge_expert.png",
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                replys.IsAdmin && !replys.IsDel
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "comment-head-delete",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteBtnClick(
                                              replys.CommentId,
                                              index
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment-time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$calcTime(replys.ReplyTime + "000")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "comment-content" }, [
                                _vm._v("\n                        回复 "),
                                _c("span", [_vm._v(_vm._s(replys.ReplyTo))]),
                                _vm._v(
                                  "：" +
                                    _vm._s(replys.ReplyMessage) +
                                    "\n                    "
                                )
                              ]),
                              _vm._v(" "),
                              false &&
                              replys.ReplyMessage.length &&
                              (replys.ReplyToADAccount !==
                                _vm.mainCommentInfo.ADAccount ||
                                replys.ReplyToADAccount !==
                                  replys.ReplyADAccount)
                                ? _c(
                                    "div",
                                    { staticClass: "comment-content" },
                                    [
                                      _vm._v("\n                        回复 "),
                                      _c("span", [
                                        _vm._v(_vm._s(replys.ReplyTo))
                                      ]),
                                      _vm._v(
                                        "：" +
                                          _vm._s(replys.ReplyMessage) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              false &&
                              replys.ReplyMessage &&
                              replys.ReplyMessage.length &&
                              !(
                                replys.ReplyToADAccount !==
                                  _vm.mainCommentInfo.ADAccount ||
                                replys.ReplyToADAccount !==
                                  replys.ReplyADAccount
                              )
                                ? _c(
                                    "div",
                                    { staticClass: "comment-content" },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(replys.ReplyMessage) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              replys.AttachList && replys.AttachList.length
                                ? _c(
                                    "div",
                                    { staticClass: "comment-attachment" },
                                    _vm._l(replys.AttachList, function(
                                      attachment,
                                      index
                                    ) {
                                      return index < 3
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "source-img-wrapper",
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showImg(
                                                    index,
                                                    replys.AttachList
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "source-img",
                                                attrs: { src: attachment },
                                                on: {
                                                  error: _vm.$commentImgErr
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm.replyList &&
                  _vm.totalReplyCount > 10 &&
                  _vm.checkMoreComment
                    ? _c("div", { staticClass: "more-leave" }, [
                        _c(
                          "div",
                          {
                            staticClass: "more-leave-btn",
                            on: { click: _vm.checkMoreCommentClick }
                          },
                          [_vm._v("查看更多评论")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("loading-more")
                ],
                2
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ajaxDone && _vm.KBTitle
        ? _c(
            "div",
            { staticClass: "back-to-k-bar", on: { click: _vm.goDetail } },
            [
              _c("span", [_vm._v(_vm._s(_vm.KBTitle))]),
              _c("span", [_vm._v("查看原文")])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ajaxDone && (!_vm.mainCommentInfo.IsDel || _vm.replyList.length)
        ? _c("div", { staticClass: "answer-bar" }, [
            _c(
              "div",
              {
                staticClass: "answer-input",
                on: {
                  click: function($event) {
                    return _vm.addComment(_vm.mainCommentInfo, _vm.matchedReply)
                  }
                }
              },
              [_vm._v("回复 " + _vm._s(_vm.replyPlaceHolder) + ":")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.callCommentInput && _vm.$route.name === "replyList"
        ? _c("leave-question", {
            attrs: { commentInfo: _vm.commentInfo },
            on: { successPush: _vm.successPush }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.callDeleteWarning
        ? _c("quit-message", {
            attrs: {
              mask: "mask",
              messageTitle: _vm.delMessageTitle,
              messageText: _vm.delMessageText,
              queryBtn: _vm.delQueryBtn
            },
            on: {
              closeQuitWarning: _vm.closeDelWarning,
              eventContinue: _vm.deleteContinue
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.callQuitWarning
        ? _c("quit-message", {
            attrs: {
              messageTitle: _vm.messageTitle,
              messageText: _vm.messageText,
              queryBtn: _vm.queryBtn
            },
            on: {
              closeQuitWarning: _vm.closeQuitWarning,
              eventContinue: _vm.eventContinue
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.callUnauthorize
        ? _c("unauthorize", { attrs: { unauthorizeType: _vm.unauthorizeType } })
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceList && _vm.sourceList.length
        ? _c("photo-package", {
            ref: "sourcePreview",
            attrs: {
              list: _vm.sourceList,
              options: _vm.options,
              selector: ".source-img"
            },
            on: { "on-close": _vm.closeHandler }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("water-mark", { ref: "watermark" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-10ae9404", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-10ae9404","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/replyList.vue
// module id = null
// module chunks = 